import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "exercise-design"
};
var _hoisted_2 = {
  class: "filter-bar"
};
var _hoisted_3 = {
  class: "filter-bar-left"
};
var _hoisted_4 = {
  class: "filter-bar-right"
};
var _hoisted_5 = {
  key: 0,
  class: "empty-box"
};
var _hoisted_6 = {
  key: 0,
  class: "exercise-list"
};
var _hoisted_7 = {
  class: "list-scroll"
};
var _hoisted_8 = {
  class: "exercise-box"
};
var _hoisted_9 = {
  class: "exercise-content"
};
var _hoisted_10 = {
  class: "exercise-btns"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  class: "exercise-list-page"
};
var _hoisted_14 = {
  key: 1,
  class: "empty-box"
};
import { MessagePlugin } from 'tdesign-vue-next';
import { onMounted, ref, toRaw } from 'vue';
import { env_name } from '@/util';
import { getStore } from '@/util/store.js';
import { getExercisePage } from '@/api/index-bei';
import { getAppUrl, getXkwUrl } from '@/util/inspirationCentre';
import { SearchIcon } from 'tdesign-icons-vue-next';
import TopLinks from './components/TopLinks.vue';
import QuestionContent from './components/QuestionContent.vue';
import QuestionAnalysis from './components/QuestionAnalysis.vue';
import AiTips from './components/AiQuestionStem.vue';
import { skipUrl as skipUrlOpen } from '@/util/util';
import { xkwJump } from '@/util/paper.js';
export default {
  __name: 'Exercises',
  setup: function setup(__props) {
    var accessToken = getStore({
      name: 'access_token'
    });
    var inspirationCentre = ref('');
    var prepareLesson = ref('');
    var xuekewang = ref('');
    var loading = ref(true);
    var getTopLinks = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getAppUrl('inspirationCentre');
            case 1:
              _t = _context.v;
              if (_t) {
                _context.n = 2;
                break;
              }
              _t = '';
            case 2:
              inspirationCentre.value = _t;
              _context.n = 3;
              return getAppUrl('prepareLesson');
            case 3:
              _t2 = _context.v;
              if (_t2) {
                _context.n = 4;
                break;
              }
              _t2 = '';
            case 4:
              prepareLesson.value = _t2;
              xuekewang.value = getXkwUrl() || '';
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getTopLinks() {
        return _ref.apply(this, arguments);
      };
    }();
    var timeSort = ref('desc');
    var toggleTimeSort = function toggleTimeSort() {
      timeSort.value = timeSort.value === 'desc' ? 'asc' : 'desc';
      getList();
    };
    var searchKey = ref('');
    var currentPage = ref(1);
    var pageSize = ref(20);
    var total = ref(0);
    var onPageSizeChange = function onPageSizeChange(size) {
      pageSize.value = size;
      getList();
    };
    var onChange = function onChange(pageInfo) {
      currentPage.value = pageInfo.current;
      getList();
    };
    var exerciseList = ref([]);
    var getList = function getList() {
      loading.value = true;
      var params = {
        curriculumCategory: 'NATION',
        order: timeSort.value,
        search: searchKey.value,
        current: currentPage.value,
        size: pageSize.value,
        periodCode: '',
        subjectCode: '',
        tutorialVersionCode: '',
        tutorialId: '',
        firstDirId: '',
        secondDirId: '',
        threeDirId: '',
        fourDirId: ''
      };
      getExercisePage(params).then(function (res) {
        console.log('getExercisePage', res);
        if (res.data.code === 0) {
          exerciseList.value = res.data.data.records;
          total.value = res.data.data.total;
        }
      }).finally(function () {
        loading.value = false;
      });
    };
    var handleSearch = function handleSearch() {
      currentPage.value = 1;
      getList();
    };
    var refreshList = function refreshList() {
      getList();
    };
    var handleCreateExercise = function handleCreateExercise() {
      if (inspirationCentre.value) {
        var url = "".concat(inspirationCentre.value, "?inspirationCentre=%2Fsub-inspiration-centre-svc%2FeditExcersise&token=").concat(accessToken);
        window.open(url);
      } else {
        MessagePlugin.warning('暂无应用权限！');
      }
    };
    var goTo = function goTo(appUrl, type) {
      console.log('goTo', appUrl, type);
      if (appUrl) {
        if (type === 'xkw') {
          xkwJump();
        } else {
          var url = "".concat(appUrl, "?inspirationCentre=%2Fsub-inspiration-centre-svc%2Fexercise&token=").concat(accessToken);
          skipUrlOpen(url);
        }
      } else {
        MessagePlugin.warning('暂无应用权限！');
      }
    };
    var focus = ref(undefined);
    var focusValue = function focusValue(value) {
      focus.value = value;
    };
    var toggleAnalysis = function toggleAnalysis(exercise) {
      exercise.view = !exercise.view;
    };
    var handleEdit = function handleEdit(exercise) {
      if (!inspirationCentre.value) {
        MessagePlugin.warning('暂无应用权限！');
        return;
      }
      var commonName2 = env_name ? "//".concat(env_name, "web.zhixuehuijiao.cn") : "//web.zhixuehuijiao.cn";
      window.open("".concat(commonName2, "/inspirationCentre?inspirationCentre=%2Fsub-inspiration-centre-svc%2FeditExcersise%3Fid%3D").concat(exercise.resId, "%26uniqueCode%3D").concat(exercise.uniqueCode, "&token=").concat(accessToken));
    };
    onMounted(function () {
      getTopLinks();
      getList();
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_loading = _resolveComponent("t-loading");
      var _component_t_pagination = _resolveComponent("t-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(['btn-sort', timeSort.value]),
        onClick: toggleTimeSort
      }, [_cache[5] || (_cache[5] = _createTextVNode(" 编辑时间", -1)), _createVNode(_component_svg_icon, {
        class: "icon-order",
        name: "course-order",
        size: "16"
      })], 2), _createVNode(_component_t_input, {
        modelValue: searchKey.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return searchKey.value = $event;
        }),
        placeholder: "请输入内容"
      }, {
        suffixIcon: _withCtx(function () {
          return [_createVNode(_unref(SearchIcon), {
            style: {
              cursor: 'pointer'
            },
            onClick: handleSearch
          })];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "btn-refresh",
        onClick: refreshList
      }, [_cache[6] || (_cache[6] = _createTextVNode(" 刷新", -1)), _createVNode(_component_svg_icon, {
        class: "icon-refresh",
        name: "course-refresh",
        size: "16"
      })]), _createElementVNode("div", {
        class: _normalizeClass(['btn-create', {
          disabled: !inspirationCentre.value
        }]),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return goTo(inspirationCentre.value);
        })
      }, [_createVNode(_component_svg_icon, {
        class: "icon-create",
        name: "prepare-icon",
        size: "16"
      }), _cache[7] || (_cache[7] = _createTextVNode("前往备课 ", -1))], 2), _createElementVNode("div", {
        class: _normalizeClass(['btn-create', {
          disabled: !inspirationCentre.value
        }, 'xkw']),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return goTo(xuekewang.value, 'xkw');
        })
      }, [_createVNode(_component_svg_icon, {
        class: "icon-create",
        name: "xkw",
        size: "16"
      }), _cache[8] || (_cache[8] = _createTextVNode("前往学科网 ", -1))], 2), _createElementVNode("div", {
        class: _normalizeClass(['btn-create', {
          disabled: !inspirationCentre.value
        }]),
        onClick: handleCreateExercise
      }, [_createVNode(_component_svg_icon, {
        class: "icon-create",
        name: "course-exercise",
        size: "16"
      }), _cache[9] || (_cache[9] = _createTextVNode("创建习题 ", -1))], 2)])]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_t_loading, {
        text: "数据加载中...",
        size: "small"
      })])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [exerciseList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exerciseList.value, function (item) {
        var _item$exercise;
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "exercise-list-item"
        }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(QuestionContent, {
          question: item,
          focus: focus.value,
          onFocus: focusValue
        }, null, 8, ["question", "focus"])]), _createElementVNode("div", _hoisted_10, [item.view ? (_openBlock(), _createBlock(AiTips, {
          key: 0,
          content: item === null || item === void 0 || (_item$exercise = item.exercise) === null || _item$exercise === void 0 ? void 0 : _item$exercise.exercise
        }, null, 8, ["content"])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "exercise-btns-item",
          onClick: function onClick($event) {
            return toggleAnalysis(item);
          }
        }, _toDisplayString(item.view ? '隐藏解析' : '查看解析'), 9, _hoisted_11), _createElementVNode("div", {
          class: _normalizeClass(['exercise-btns-item', {
            disabled: !inspirationCentre.value
          }]),
          onClick: function onClick($event) {
            return handleEdit(item);
          }
        }, " 编辑 ", 10, _hoisted_12)])]), item.view ? (_openBlock(), _createBlock(QuestionAnalysis, {
          key: 0,
          question: item.exercise.exercise,
          class: _normalizeClass({
            view: item.view
          })
        }, null, 8, ["question", "class"])) : _createCommentVNode("", true)]);
      }), 128))]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_t_pagination, {
        modelValue: currentPage.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return currentPage.value = $event;
        }),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[4] || (_cache[4] = function ($event) {
          return pageSize.value = $event;
        }),
        total: total.value,
        "show-jumper": "",
        pageSizeOptions: [20, 50, 100, 200, 500],
        onChange: onChange,
        onPageSizeChange: onPageSizeChange
      }, null, 8, ["modelValue", "pageSize", "total"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_svg_icon, {
        name: "empty-content",
        size: "120",
        class: "icon"
      })]))], 64))]);
    };
  }
};